import "themes/forsant/index.less";

export default {}